
import React, { useState } from "react";
import { Box, TextField, Typography, useTheme } from "@mui/material";
import SignatureDialog from "../../SignatureDialog";
import QuestionFileUpload from "../../QuestionFileUpload";
import { useTranslation } from "react-i18next";
import { deepClone } from "../../../../_helpers/deepClone";

const SignatureQuestion = ({
  q,
  sectionIndex,
  formData,
  setFormData,
  error,
  isDisabled,
  handleChange,
  handleFiles
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [currentSignQId, setCurrentSignQId] = useState(null);
  const [openSignature, setOpenSignature] = useState(false);
  const [answers, setAnswers] = useState((q.answers || []))
  
  const handleOpenSignature = (id) => {
    setCurrentSignQId(id);
    setOpenSignature(true);
  };

const handleSaveSignature = (base64) => {
  const updated = { ...formData };
  const section = updated.sections[sectionIndex];
  const questionIndex = section.questions.findIndex((item) => item.id === currentSignQId);
  if (questionIndex === -1) return;
  section.questions[questionIndex].signature = base64;
  setFormData(updated);
  handleChange(sectionIndex, q, base64);
  setOpenSignature(false);
};

  const handleClearSignature = () => {
    const updated = deepClone(formData) ;
    const section = updated.sections[sectionIndex];
    const questionIndex = section.questions.findIndex((item) => item.id === currentSignQId);
    if (questionIndex === -1) return;
    section.questions[questionIndex].signature = null; 
    setFormData(updated);
    handleChange(sectionIndex, q, '');
   setOpenSignature(false);
  };
 
  return (
    <Box>
      <TextField
        fullWidth
        size="small"
        autoComplete="off"
        placeholder={t("general.signatoryName")}
        value={answers?.[0] || ''}
        onChange={(e) => {
          if (handleChange) {
            handleChange(sectionIndex, q, [e.target.value])
            setAnswers([e.target.value])
          }
        }}
      />
      <Box
        sx={{
          my:2 ,
          height: 80,
          width: 200,
          border: `1px dashed ${theme.palette.divider}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => handleOpenSignature(q.id)}
      >
        {!q.signature || !q.signature.content ? (
          t("questionnaire.form.signature.clickToSign")
        ) : (
          <Box
            component="img"
            src={`data:image/png;base64,${q.signature.content}`}
            alt="signature"
            sx={{
              width: "100%",
              height: "100px",
              border: `1px dashed ${theme.palette.divider}`,
              borderRadius: 4,
              objectFit: "contain",
              backgroundColor: theme.palette.background.paper,
            }}
          />
        )}
      </Box>

      <QuestionFileUpload
        q={q}
        sectionIndex={sectionIndex}
        isDisabled={isDisabled}
        handleFiles={handleFiles}
      />


      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}

      <SignatureDialog
        open={openSignature}
        onClose={() => setOpenSignature(false)}
        onSave={handleSaveSignature}
        onClear={handleClearSignature}
      />
    </Box>
  );
};

export default SignatureQuestion;
